export default "/packs/images/default~9713029f59047b58a2acd65fbd962015.jpg";